// Keep unchanged cards attached so focus, image loads and scroll positions survive updates.
export function reconcileChildren(parent, children) {
    let next = parent.firstChild;
    for (const child of children) {
        if (child === next) next = next.nextSibling;
        else parent.insertBefore(child, next);
    }
    while (next) {
        const stale = next;
        next = next.nextSibling;
        stale.remove();
    }
}
export function pruneEntries(entries, keys) {
    for (const key of entries.keys()) if (!keys.has(key)) entries.delete(key);
}
export function setText(node, value) {
    if (node.textContent !== value) node.textContent = value;
}
